import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import axios from 'axios';
import Configdata from './Defaultdata';
import './home.css';
import Localdata from './Localdata';
import './cube.css';
import { arutyps,arutypsa,getsid,showhidediv,sets,loadwidgate,getloginuser,setlogininfo,gets,authuloged,chkucode,showdelay,closedelay} from './userdefaultdata';
import { getmessage,wrongmsg,clearform,displayprofile,getstacmessage } from './Dynamictable';
import {txtnullchk,isvaluenull,isvalidatemail,isvalidpin,isvalidatedob,isequal,isvldunm} from './validation';
import Usersession from './Usersession';
import {chkwbauthu} from './Webconnet';

export default class Signup extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "";
	
  	}
	
    state = {

	
	usertyeopt:2,
	citycode:'',
	dob:"",
        name: "",
        type: "1",
        pin: "",
	email:"",
        msg: "",
	passwrd:"",
        typeoption: null,
        respdata: null,
	usercode: '',
        isVisible: true,
        resm: null,
        url: "",
	usertps: [{ value: 7, label: 'General' }],
        citycods: [{ value: 'DEL', label: 'Delhi' }],
	username:"",	
       
    };
    pagetextboxChange(event: any) {
         const id = event.target.id;
	const elvalue = event.target.value;
	
        if(id == 'txtusername'){
        
	 this.setState({ name: elvalue });
	}
	else if(id == 'txtemailid'){
	 this.setState({ email: elvalue });
	}
	else if(id == 'txtphno'){
	 this.setState({ pin: elvalue });
	}
	else if(id == 'txtposword'){
	 this.setState({ passwrd: elvalue });
	}
	else if(id == 'txtdob'){
	 this.setState({ dob: elvalue });
	}
	else if(id == 'txtpin'){
	 this.setState({ pin: elvalue });
	}
   }
   isvalidatedctrls(){
	let isvalidate = true;
	
	if(isvaluenull(this.state.name)){
	  getmessage('Name should not Blanck','');
	  return false;
	}
	 else if(this.state.name.length < 4 || this.state.name.length > 14){
	  getmessage('User name within 4 to 14 alphanumeric','');
	  return false;
	}

        else if(!isvldunm(this.state.name)){
          getmessage('Only alphanumeric allowed','');
	  return false;

	}
	else if(!isvalidatedob(this.state.dob)){
	  getmessage('Enter valid DOB','');
	  return false;
	}
	else if(this.state.usertyeopt == 2){
	 getmessage('Please select gender','');
	  return false;

	}
	else if(isvaluenull(this.state.dob)){
	 getmessage('Enter Date of Birth','');
	  return false;

	}	
	else if(!isvalidpin(this.state.pin)){
	 getmessage('Not a valid pin no','');
	  return false;

	}	
	else if(!isvalidatemail(this.state.email)){
		 getmessage('Please enter a valid mail Id','');
	  return false;
	}
	else if(isvaluenull(this.state.pin)){
	  getmessage('pin No should not Blanck','');
	  return false;
	}
	else if(isvaluenull(this.state.passwrd)){
	  getmessage('Password should not Blanck','');
	  return false;
	}
	else if(isvaluenull(this.state.email)){
	  getmessage('Email should not Blanck','');
	  return false;
	}
	else if(this.state.passwrd.length < 8 || this.state.passwrd.length > 12 ){
	  getmessage('Password length between 8 to 12 charectors','');
	  return false;
	}
        
	
	return isvalidate;	
    }	
    
    utypeChange(event: any) {

        const typevalue = event.value;
       
        this.setState({ usertyeopt: typevalue });
	
    }
   
	
    Homehitcount() {
              
        try {
          
            //const promiseAwait = fetch(Configdata.srvurl + '/Hitcountinput');
          }
        catch (e) {
            debugger;


        }
    }
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
   
    componentDidMount() {
        debugger;
     
        
        this.setserverurl();
        this.setState({ usertps: arutyps });
        const issignup =   Usersession.getCode()
       if(issignup != "NA"){
       
         const chk = chkwbauthu();
        //alert(chk);
        if(chk){
	loadwidgate('container',16);
	}else{   
	const ucd = Usersession.getCode();
        if(ucd == "") this.pinentery();
	else chkucode();
	}

     }

    }
    pinentery(){
	 showhidediv(true,'Signupdiv');
          showhidediv(false,'pinmailcheckdiv');
    }
    Securitycheck(){
         sets('79','NA','testuser','NA');

	const superid = getsid();
      // alert(superid);
        const tempsubusers =[[{mid:1, mpid:superid, mupoints:10, mofferid:0,muname:"testuser", mudob:"1999-07-02",mutypeid:0,upfpid:0,msgalow:0}]];
        if(superid > 0)
	{
	 const uinfo = 'NA-'+ superid;
	 //getloginuser(uinfo);
	setlogininfo(tempsubusers);
	showhidediv(true,'Signupdiv');
	//showhidediv(false,'pincheckdiv');

	}
        else{
	 showhidediv(false,'Signupdiv');
	showhidediv(true,'pincheckdiv');

	}
    }
    setusercode(code:any){
	document.cookie = code;
    }
    checkpin(e:any){
        const localpin = gets('Userpin');
        const cpin = document.getElementById('txtpin') as HTMLInputElement;
       if(cpin){
        var tx = cpin.value;
	if(isequal(tx,localpin)){
	   showhidediv(true,'signuptop');
	   
	   loadwidgate('container',5);
           
	}
	else{
          getmessage('Invalid pin','');

	}
	}
	e.preventDefault()

    }
checkmailpin(e:any){
        const localpin = gets('Userpin');
        const cpin = document.getElementById('txtpin1') as HTMLInputElement;
        const cmail = document.getElementById('txtmail1') as HTMLInputElement;
	const mailv = cmail.value;
        const pinv = cpin.value;
       authuloged(mailv,pinv,'mailpn');
       
	e.preventDefault()

    }

    forgotpin(e:any){
	
         //chkucode();
	loadwidgate('container',6);

	e.preventDefault()

    }
    
    typeselect(e: any){
		
		
		const eid = e.target.id;
		e.target.style.backgroundColor = 'green';
		
		e.preventDefault();

     };
     DisplayLogindiv(e:any){
      loadwidgate('container',7);
      e.preventDefault();

     }
     insertusersignup(e: any){
	 try {
		if(this.isvalidatedctrls()){
		getmessage('On Process Please wait.....','');
               showdelay();
          	const udb = this.state.dob;
               // alert(ctcod);
		const emlid = this.state.email;
		const pin = this.state.pin;
            	const pid = this.state.usertyeopt==0?1:0;	
		const nm =this.state.name;
                const response = axios.post(Configdata.srvurl + '/insertuser', {
    		uname: nm,
    		utypeid: pid,
    		uemail: emlid,
                upin: pin,
		udob: udb,
		upass:this.state.passwrd
		
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		 
		const usercd = result.data;
                const ucd = usercd.split(',')[0]; 
                 const sid = usercd.split(',')[1]; 

		const uniqcode = 'Security code is :  ' + ucd;
               // alert(usercd);
                sets(sid,pin,nm,'NA');
                 Usersession.setCode(ucd);
                 Usersession.setGuestmailid(nm);
		getstacmessage(uniqcode,'');
		// this.setState({ usercode: usercd });
                const clr = clearform('frmsignup');
		//this.clearadminusermailid();
		//displayprofile();
	        
		this.pinentery();
                 closedelay();
	        });		
              }
		
	   }
          }
        catch (e) {
           // debugger;
                closedelay();

		wrongmsg();
        }

	
      	e.preventDefault();


     }	
     
     clearadminusermailid(){

	const adminmail = Usersession.getGuestmailid();
        if(adminmail == 'test.in' || adminmail == 'test.in') 
		Usersession.setGuestmailid('user');
     }	
     displaysinupdv(e:any){
	showhidediv(false,'Signupdiv');
	showhidediv(true,'pinmailcheckdiv');
     }
    
 render() {

   
     return (

         <form id="frmsignup">
        <div id="signuptop" className="per100">
	<div className="per100" id="Signupdiv">
	 <div className="postingouterdiv" style={{overflowX:'hidden',overflowY:'auto',height:'93vh'}}>
	  <div className="postingtablediv">

	    <table style={{height:'70vh',backgroundColor:'antiquewhite'}} className="postingtable">
		

		<tr>
		<td>
			<div className="postingrowdiv">
			<input type="text" placeholder="Enter User name" onChange={e => this.pagetextboxChange(e)} id="txtusername" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div style={{backgroundColor:'#916a6a'}} className="postingrowdropdown">
    <Select placeholder="Select Gender"  onChange={e => this.utypeChange(e) } id="utyp" options={this.state.usertps} className="postingtxtbox" />

			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div style={{display:'none'}} className="postingrowdropdown">
    <Select placeholder="Select City" id="ucity" options={this.state.citycods} className="postingtxtbox" />
		</div>
		<div className="postingrowdiv">
                 
		<input type="text"  placeholder="Enter DOB(yyyy-mm-dd)" onChange={e => this.pagetextboxChange(e)} id="txtdob" 	className="postingtxtbox" />
		</div>

			
		</td>
		</tr>

		<tr>
		<td>
			<div className="postingrowdiv">
		<input type="email" onChange={e => this.pagetextboxChange(e)} placeholder="Enter Email Id" id="txtemailid" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdiv">
		<input type="text" placeholder="Enter four digit pin" id="txtphno" onChange={e => this.pagetextboxChange(e)} className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdiv">
		<input type="text" placeholder="Enter Password" onChange={e => this.pagetextboxChange(e)} id="txtposword" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdiv">
				
				  
				    <a href="#" onClick={e => this.insertusersignup(e)} title="Partner">

					<div className="searchtype" id="btnsingup" style={{backgroundColor:'gray',marginLeft:'0px',float:'right'}}>
			  			I am 18+	
					</div>
				    </a>
		     		
<a href="#" onClick={e => this.DisplayLogindiv(e)} title="Partner">

					<div className="searchtype" id="btnsingup" style={{backgroundColor:'gray',marginLeft:'0px',float:'left',height:'auto'}}>
			  			Already Registered	
					</div>
				    </a>
		     		

			</div>
			
		</td>
		</tr>
		

	   </table>
	 </div>		
	</div>
	
	</div>
        <div style={{display:'none'}} className="userpinset" id="pincheckdiv">
               
		<div id="upindiv" className="middlepivdiv">
                 <div id="pindiv" style={{height:'auto'}} className="per100">
               	  <span className="unamepin"> Welcome </span> <span className="unamepin">{this.state.name}</span>
		 </div>
		<div className="per100">
		<div style={{backgroundColor:'#ad9d4d'}} className="postingrowdiv">
		<input type="text" placeholder="Enter Pin" onChange={e=> this.pagetextboxChange(e)} id="txtpin" className="postingtxtbox" />
			</div>
			<div className="per100">
			 <a href="#" className="blanka"  onClick={e=>this.checkpin(e)}>
				<span style={{width:'20%'}} className="pinernter">Start</span>
			</a>
                        <a href="#" className="blanka"  onClick={e=>this.displaysinupdv(e)}>
				<span style={{width:'20%'}} className="pinernter">SinUp</span>
			</a>
			 <a href="#" className="blanka"  onClick={e=>this.forgotpin(e)}>
				<span style={{width:'20%'}}  className="forgotpin">Forgot Pin</span>
			</a>
			</div>

			</div>
	       </div>
	</div>
         <div style={{display:'none'}} className="pinsetwithmail" id="pinmailcheckdiv">
               
		<div id="upinmaildiv" className="mailpinchk">
                 <div id="mailpindiv" style={{height:'auto'}} className="per100">
               	  <span className="unamepin"> Welcome </span> <span className="unamepin">{this.state.name}</span>
		 </div>
		<div className="per100">
               <div style={{backgroundColor:'#ad9d4d'}} className="postingrowdiv">
		<input type="text" placeholder="Enter mailId" onChange={e=> this.pagetextboxChange(e)} id="txtmail1" className="postingtxtbox" />
			</div>
		<div style={{backgroundColor:'#ad9d4d'}} className="postingrowdiv">
		<input type="text" placeholder="Enter Pin" onChange={e=> this.pagetextboxChange(e)} id="txtpin1" className="postingtxtbox" />
			</div>
			<div className="per100">
			 
                           <a href="#" className="blanka"  onClick={e=>this.displaysinupdv(e)}>
				<span style={{width:'20%'}} className="pinernter">SinUp</span>
			</a>
			 <a href="#" className="blanka"  onClick={e=>this.forgotpin(e)}>
				<span style={{width:'20%',marginLeft:'14%'}} className="pinernter">Forgot Pin</span>
			</a>
                       <a href="#" className="blanka"  onClick={e=>this.checkmailpin(e)}>
				<span  style={{width:'20%',float:'right'}} className="pinernter">Start</span>
			</a>
			</div>

			</div>
	       </div>
	</div>

        <div style={{backgroundColor:'transparent'}} className="userloginset"  id="Logindiv">

	</div> 
        </div>
   	</form>
    
   
      );
}
}

